import * as React from 'react'
import { NewMessageEditorConnected } from './NewMessageEditorConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const NewMessageEditorExamples = () => {
  return (
    <div className="NewMessageEditorExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <NewMessageEditorConnected />
      </Provider>
    </div>
  )
}
